import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ChartTimeframeSelector from '@common/charts/chart-timeframe-selector';
import styles from './statistics-widget.css';
export function StatisticsWidgetTimeframeSelector(props) {
    const { label, ...selectorProps } = props;
    return (_jsxs("div", { className: styles.timeFrameSelector, children: [_jsx("span", { className: styles.label, children: label }), " ", _jsx(ChartTimeframeSelector, { ...selectorProps })] }));
}
